import { render, staticRenderFns } from "./OnboardingGenres.vue?vue&type=template&id=189d470c&"
import script from "./OnboardingGenres.vue?vue&type=script&lang=js&"
export * from "./OnboardingGenres.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingGenres.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports